'use client';

import { useAuthStore } from '@/store/authStore';
import Link from 'next/link';
import { usePathname, useRouter } from 'next/navigation';
import { getIntranetLinkPrefix } from '@/lib/intranet';

export default function IntranetHeader() {
  const router = useRouter();
  const pathname = usePathname();
  const prefix = getIntranetLinkPrefix(pathname);
  const { user, isInitializing, logout } = useAuthStore();

  const handleLogout = async () => {
    await logout();
    router.push(`${prefix}/auth/login`);
    router.refresh();
  };

  if (isInitializing) {
    return (
      <header className="teal-dark-bg py-2">
        <div className="container-xxl">
          <div className="d-flex justify-content-end">
            <span className="text-white-50 small">Caricamento...</span>
          </div>
        </div>
      </header>
    );
  }

  return (
    <header className="teal-dark-bg py-2">
      <div className="container-xxl">
        <div className="d-flex align-items-center justify-content-between">
          <Link
            prefetch={false}
            href={prefix || '/'}
            className="text-white text-decoration-none fw-semibold"
          >
            Intranet ASST Sette Laghi
          </Link>
          {user ? (
            <div className="d-flex align-items-center gap-3">
              <span className="text-white d-none d-md-inline small">
                {user.username}
              </span>
              <Link
                prefetch={false}
                href={`${prefix}/area-personale`}
                className="text-white text-decoration-none small"
              >
                Area personale
              </Link>
              <button
                type="button"
                className="btn btn-link text-white p-0 text-decoration-none small"
                onClick={handleLogout}
              >
                Esci
              </button>
            </div>
          ) : null}
        </div>
      </div>
    </header>
  );
}
